export { default, getServerSideProps } from '@/views/Home';
